import { Button } from "@mui/material";
import { useStyles } from "./MainCardButtonAction.styles";

import { IMainCardButtonAction } from "./MainCardButtonActionInterfaces";

const MainCardButtonAction = ({ renderIcon, onClick, title, disabled }: IMainCardButtonAction) => {
    const classes = useStyles();
    return (
        <Button
            disabled={disabled}
            variant="outlined"
            color="info"
            size="small"
            className={classes.cardActionButton}
            onClick={onClick}
        >
            {renderIcon(classes.cardActionButtonIcon)}
            {title}
        </Button>
    );
};

export default MainCardButtonAction;
